export const FETCH_ORGANISATION = 'organisation/FETCH_ORGANISATION';
export const ADD_ORGANISATION = 'organisation/ADD_ORGANISATION';
export const EDIT_ORGANISATION = 'organisation/EDIT_ORGANISATION';
export const FETCH_ORGANISATION_USER = 'dashboard/FETCH_ORGANISATION_USER';
